import React from "react";
const Briefcase = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_16399_249089)">
      <path
        d="M13.5333 4.66663H2.86662C2.13024 4.66663 1.53329 5.26358 1.53329 5.99996V12.6666C1.53329 13.403 2.13024 14 2.86662 14H13.5333C14.2697 14 14.8666 13.403 14.8666 12.6666V5.99996C14.8666 5.26358 14.2697 4.66663 13.5333 4.66663Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8666 14V3.33333C10.8666 2.97971 10.7261 2.64057 10.4761 2.39052C10.2261 2.14048 9.88691 2 9.53329 2H6.86662C6.513 2 6.17386 2.14048 5.92382 2.39052C5.67377 2.64057 5.53329 2.97971 5.53329 3.33333V14"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16399_249089">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.199959)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Briefcase;
